import router, { setupRouter } from "./router";

// setup
import { setupAntDesign } from "./setup/setupAntDesign";
import { setupGlobalComponents } from "./setup/setupGlobalComponents";
import { setupGlobalDirectives } from "./setup/setupGlobalDirectives";
import { setupGlobalMethods } from "./setup/setupGlobalMethods";
import { setupThirdLib } from "./setup/setupThirdLib";
import { setupGlobalFilters } from "@/core/setup/setupGlobalFilters";
import { setupCkeditor } from "@/core/setup/setupCkeditor";
// hooks
import { useEventbus } from "./hooks/useEventbus";
import eventBus from "./hooks/EventBus";

// services
import { HttpService } from "./services/http.service";
import { TabService } from "./services/tab.service";
import { StorageService } from "./services/storage.service";
import Storage from "./services/storage";
import { FileUploadService } from "./services/file-upload.service";
import { BizFileService } from "./services/biz-file.service";
import { MenuService } from "./services/menu.service";
let lockr = new Storage("cpms_");
// constants
import { TABS_ROUTES, TABS_WHITE_LIST, CACHED_TABS_ROUTES, CACHED_NOTICE_LIST } from "./constant";

export * from "./interface";
export {
  router,
  setupRouter,
  setupAntDesign,
  setupGlobalComponents,
  setupGlobalDirectives,
  setupGlobalMethods,
  setupThirdLib,
  setupGlobalFilters,
  useEventbus,
  setupCkeditor,
  HttpService,
  TabService,
  StorageService,
  FileUploadService,
  BizFileService,
  MenuService,
  TABS_ROUTES,
  CACHED_TABS_ROUTES,
  TABS_WHITE_LIST,
  CACHED_NOTICE_LIST,
  eventBus,
  lockr,
};
